import ScrollTrigger from "gsap/ScrollTrigger";
import { throttle } from "lodash";


class MobileSlider {
  breakpoint = 576;
  constructor($el) {
    this.$el = $el;
    this.slickInitialized = false;
    this.init();
  }

  init = () => {
    this.$el.on('init', this.onInit);
    this.$el.on('destroy', this.onDestory);
    import("slick-carousel").then(() => {
      // bind resize event
      $(window).on('resize', throttle(this.onResize, 200));

      if(window.innerWidth < this.breakpoint) {
        this.initSlick();
      }
    });
  };

  onResize = () => {
    if(window.innerWidth < this.breakpoint && !this.slickInitialized) {
      this.initSlick();
    }

    if(window.innerWidth >= this.breakpoint && this.slickInitialized) {
      this.destroySlick();
    }
  }

  initSlick = () => {
    $(this.$el).slick({
      infinite: false,
      speed: 500,
      dots: false,
      autoplay: false,
      fade: false,
      arrows: false,
      swipe: true,
      slidesToShow: 1.2,
      slidesToScroll: 1,
    });
  };

  destroySlick = () => {
    if(this.slickInitialized) {
      this.$el.slick('unslick');
    }
  };

  onInit = () => {
    this.slickInitialized = true;
    ScrollTrigger.refresh();
  };

  onDestory = () => {
    this.slickInitialized = false;
    ScrollTrigger.refresh();
  };  
}

export default MobileSlider;
